import React from "react";
import { Switch, Route } from "react-router-dom";
import DarksideViews from "views/darkside-views";

export const DarksideLayout = () => {
	return (
		<div className="auth-container">
			<Switch>
				<Route path="" component={DarksideViews} />
			</Switch>
		</div>
	);
};

export default DarksideLayout;
